<template>
  <b-col
    class="px-0"
  >
    <b-input-group>
      <b-select
        :state="!v.$anyError && null"
        :value="field"
        :options="filteredFields"
        @input="$emit('update:field', $event)"
      />
    </b-input-group>
  </b-col>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import { FieldTypes } from '@/types'
import { UNIT_TYPE_MONETARY } from '@/constants'

const props = {
  field: {
    type: String,
    required: true,
  },
  v: {
    type: Object,
    required: true,
  },
  chartUnit: {
    type: String,
    required: true,
  },
}

@Component
export default class CategoryRow extends Vue.extend({ props }) {
  get fieldMap () {
    return this.$typedStore.visualisationApp.fieldMap
  }

  get fieldsMatchingChartUnit () {
    return this.fieldMap.filter(({ unit, type }) => {
      if (type === FieldTypes.NUMERIC || type === FieldTypes.CALCULATION) {
        return unit === this.chartUnit
      }
      if (type === FieldTypes.MONETARY) {
        return this.chartUnit === UNIT_TYPE_MONETARY
      }
      return false
    })
  }

  get filteredFields () {
    return this.fieldsMatchingChartUnit
      .map(({ name, column }) => ({ value: column, text: name }))
  }
}

</script>
